import { get, writable } from 'svelte/store';

const STORAGE_KEY = 'shelly_dev_all_energy_widgets_gallery';

const readInitialValue = (): boolean => {
	try {
		return localStorage.getItem(STORAGE_KEY) === 'true';
	} catch {
		return false;
	}
};

/**
 * Dev-only virtual dashboard (`/dash/-104`) that lists every energy widget type.
 * Off by default; enable from the Dev Modal so it does not sit in the dashboard tab rail.
 */
export const allEnergyWidgetsGalleryEnabled = writable<boolean>(readInitialValue());

allEnergyWidgetsGalleryEnabled.subscribe((value) => {
	try {
		localStorage.setItem(STORAGE_KEY, String(value));
	} catch {
		// localStorage may be unavailable
	}
});

export const isAllEnergyWidgetsGalleryEnabled = (): boolean => get(allEnergyWidgetsGalleryEnabled);

export const setAllEnergyWidgetsGalleryEnabled = (enabled: boolean) => {
	allEnergyWidgetsGalleryEnabled.set(enabled);
};
